import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination, Virtual } from "swiper/modules";
import * as S from "./styles";
import "swiper/swiper-bundle.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import './styles.scss'

// Importando as imagens
import imgTestemonial1 from '../../img/depoiments/_biellvisionario.png'
import imgTestemonial2 from '../../img/depoiments/fptrader.png'
import imgTestemonial3 from '../../img/depoiments/kennedy__xz.png'
import imgTestemonial4 from '../../img/depoiments/lucasm_mariano.png'
import imgTestemonial5 from '../../img/depoiments/nicolasluizmkt.jpg'

const testimonialsData = [
  {
    image: imgTestemonial1,
    name: "Felipe Vieira",
    testimonial: "O Futscore mudou meu jogo nas apostas! Com dicas personalizadas e estatísticas ao vivo, agora eu sei exatamente onde colocar meu dinheiro. Recomendo a todos!"
  },
  {
    image: imgTestemonial2,
    name: "Gabriel Lima",
    testimonial: "Minhas apostas eram só intuição até conhecer o Futscore. Com estatísticas em tempo real e ensinamentos sobre surebets, sinto-me confiante e informada. É como ter um consultor pessoal de apostas ao meu lado. Incrível!"
  },
  {
    image: imgTestemonial3,
    name: "Kennedy William",
    testimonial: "O Futscore revolucionou minha abordagem nas apostas. Análises detalhadas, dicas certeiras e a descoberta das surebets fizeram toda a diferença. Recomendo para quem leva apostas a sério."
  },
  {
    image: imgTestemonial4,
    name: "Nicolas Luiz",
    testimonial: "Futscore mudou meu jeito de apostar. Estatísticas em tempo real e insights sobre surebets são um combo perfeito. Fico mais a vontade para fazer escolhas inteligentes. Um verdadeiro parceiro nas apostas!"
  },
  {
    image: imgTestemonial5,
    name: "Lucas Mariano",
    testimonial: "Como assinante do Futscore, minhas apostas se tornaram mais inteligentes e rentáveis. Dicas precisas, estatísticas ao vivo e a estratégia de surebets são incríveis. Recomendo a todos que buscam sucesso nas apostas esportivas."
  },
  // Adicione mais objetos conforme necessário
];


const TestimonialsSection: React.FC = () => {
  return (
    <S.TestimonialsSection>
      <h1>PROVAS <b>SOCIAIS</b> </h1>
      <p> Descubra o que nossos clientes têm a dizer! Em nossa jornada para fornecer excelência, valorizamos cada feedback e experiência compartilhada conosco.</p>
      <Swiper
        modules={[Virtual, Navigation, Pagination, Autoplay]}
        centeredSlides={true}
        spaceBetween={150}
        autoplay={{ delay: 3000 }}
        pagination={{
          el: ".swiper-pagination",
          clickable: true,
        }}
        navigation={{
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        }}
        breakpoints={{
          768: {
            slidesPerView: 1,
          },
          992: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 3,
          },
        }}
      >
        {testimonialsData.map((testimonial, index) => (
          <SwiperSlide key={index}>
            <S.TestimonialCard>
              <S.TestimonialImage src={testimonial.image} alt={`Foto do depoente ${index + 1}`} />
              <div>
                <h3>{testimonial.name}</h3>
                <br/>
                <p>{testimonial.testimonial}</p>
              </div>
            </S.TestimonialCard>
          </SwiperSlide>
        ))}
        <div className="swiper-pagination"></div>
        <div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div>
      </Swiper>
    </S.TestimonialsSection>
  );
};

export default TestimonialsSection;
